import { render, staticRenderFns } from "./cr_raw_html.vue?vue&type=template&id=bfb10e82&"
import script from "./cr_raw_html.vue?vue&type=script&lang=js&"
export * from "./cr_raw_html.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/cp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bfb10e82')) {
      api.createRecord('bfb10e82', component.options)
    } else {
      api.reload('bfb10e82', component.options)
    }
    module.hot.accept("./cr_raw_html.vue?vue&type=template&id=bfb10e82&", function () {
      api.rerender('bfb10e82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/crud/cr_raw_html.vue"
export default component.exports